import styled, { css } from 'styled-components';
import {
    headlineSizeL,
    headlineSizeXl,
    inputLabelMargin,
    textMSize,
    textXSSize,
    textMBigSize
} from '../../tokens';
import { themeable } from 'themes/utils';
import Button from 'ui/Button/Button';
import { notDesktopMediaQuery } from 'utils/mediaQuery';

import { Link } from 'react-router-dom';

export const SIDES_MAIN_PADDING = 24;

export const BlueLink = styled(Link)`
    color: rgb(
        113,
        142,
        191
    ); // можно использовать другой голубой, если есть в теме
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const HeadlineBase = styled.h1`
    font-size: ${headlineSizeL};
    color: ${themeable('textColor')};
    font-weight: 400;

    text-align: center;
`;

export type SHeadlineProps = {
    $disableMargin?: boolean;
};

export const Headline = styled(HeadlineBase)<SHeadlineProps>`
    ${({ $disableMargin }) =>
        !$disableMargin &&
        css`
            margin-bottom: 24px;

            ${notDesktopMediaQuery(css`
                margin-bottom: 12px;
            `)}
        `}
`;

export const HeadlineXl = styled.h2`
    font-size: ${headlineSizeXl};
    color: ${themeable('textColor')};
    font-weight: 500;
    text-align: center;
    margin-bottom: 24px;
`;

export const BigHeadline = styled(HeadlineXl)`
    font-weight: 600;
    margin-bottom: 12px;
`;

export const TextMBig = styled.span`
    font-size: ${textMBigSize};
    font-weight: 400;
    line-height: 1.22;
    letter-spacing: 0px;
`;

//обычный белый по больше текст
export const TextL = styled.p`
    color: ${themeable('textColor')};
    //font-family: Barlow;
    font-size: 24px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: 0%;
`;

export const TextLNormal = styled(TextL)`
    font-weight: 400;
`;

export const TextS = styled.span`
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0%;
`;

export const TextXS = styled.span`
    font-size: ${textXSSize};
    line-height: 1.17;
`;

//обычный белый по меньше текст
export const TextM = styled.span`
    //font-family: Inter;
    font-size: ${textMSize};
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0%;
`;
//обычный серый текст
export const GrayTextM = styled(TextM)`
    color: #abbbc2;
`;
//обычный синий цвет
export const BlueTextM = styled(TextM)`
    color: ${themeable('labelColor')};
`;

export const absoluteMixin = css`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
`;

export const RelativeContainer = styled.div`
    position: relative;
`;

export const AutoFlexButton = styled(Button)`
    flex: none !important;
    margin-top: ${inputLabelMargin};
`;

export const CenterContainer = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: auto;

    width: 100%;
    min-height: 100%;
    text-align: center;
`;

export type DisabledProps = {
    $disabled?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const linkMixin = css<DisabledProps & any>`
    margin: 0 auto;
    display: block;
    width: max-content;

    ${({ $disabled }) => css`
        color: ${themeable($disabled ? 'textColor' : 'primaryColor')};
        ${$disabled &&
        css`
            opacity: 0.7;
        `}
        cursor: ${$disabled ? 'inherit' : 'pointer'};
    `}
`;

export const glassMixin = css`
    background: rgba(45, 48, 62, 0.5);
    backdrop-filter: blur(36px);
`;
